<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="chap-number-new"><span class="poem-italic CharOverride-2">Other titles from Islandport Press</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="poem-italic CharOverride-3">The Door to January</span><span class="poem-italic CharOverride-4"> by Gillian French</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="poem-italic CharOverride-3">The Sugar Mountain Snow Ball </span><span class="poem-italic CharOverride-4">by Elizabeth Atkinson</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="poem-italic CharOverride-3">Azalea, Unschooled </span><span class="poem-italic CharOverride-4">by Liza Kleinman</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="poem-italic CharOverride-3">Uncertain Glory</span><span class="poem-italic CharOverride-4"> by Lea Wait</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="poem-italic CharOverride-3">The Five Stones Trilogy</span><span class="poem-italic CharOverride-4"> by G. A. Morgan</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame _idGenObjectStyleOverride-1" id="_idContainer004">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// what_wind_can_tell_you_interior_12_pt1.vue?1765b357